import React from "react";
import "./index.scss";
export const ServiceCards = ({ items, title, description }) => {
  return (
    <div className="introService width-service-cards">
      <div className="introService-container mt-5 mb-5">
        <div className="row  g-3 w-100 align-items-center mt-5 justify-content-center">
          <div className="col-12 col-md-4 ">
            <div className="introService-title">{title}</div>
            <div className="introService-description mt-3">{description}</div>
          </div>
          <div className="col-12 col-md-8 ">
            <div className="row ps-0 justify-content-center g-5 w-100 align-items-stretch ms-0">
              {items.map((item, index) => (
                <div className="col-12 col-md-4 d-flex">
                  <div className="avantage-card p-4">
                    <div className="icon mb-3">{item.icon}</div>
                    <p className="avantage-text mb-0">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
